import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const servicesSlice = createSlice({
  name: "services",
  initialState,
  reducers: {
    servicesLoading(state) {
      state.loading = true;
      state.error = null;
    },
    servicesError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setServicesList(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const { servicesLoading, servicesError, setServicesList } =
  servicesSlice.actions;

export default servicesSlice.reducer;
